import config from 'config'
import qs from 'querystring'
import pick from 'lodash/pick'
import { getUserInfo } from './user'

function getReportBase (exerciseId) {
  const query = qs.stringify({
    exerciseId,
    token: getUserInfo() ? getUserInfo().token : ''
  })
  return fetch(`${config.api.ti}/report?${query}`)
    .then(res => res.json())
}

export function getQuestions (qs) {
  const token = getUserInfo() ? getUserInfo().token : ''

  return fetch(`${config.api.ti}/questions${qs}&token=${token}`)
    .then(res => res.json())
    .then(json => {
      if (json.code !== 0) {
        throw new Error(json.msg)
      }
      const {
        isBought,
        tagName,
        practiceList,
        questionList
      } = json.data
      const isPractices = Boolean(practiceList)
      const practices = practiceList && practiceList.practice.map(({
        id, name, questions, questionIds
      }) => {
        const answered = questions.some(i => i.answerId && i.answerId > 0)
        const videoDisplay = questions.some(i => i.ctqaId && i.ctqaId > 0)
        const videoHighlight = isBought || questions.every(i => i.audition)
        return {
          name,
          answered,
          videoDisplay,
          videoHighlight,
          reportStatus: questions[0].reportStatus || -1,
          answerId: questions[0].answerId || -1,
          pid: id,
          qid: questionIds[0]
        }
      })
      const questions = questionList && questionList.questions.map(({
        id, name, answerId, reportStatus, audition, ctqaId
      }) => ({
        name,
        answered: Boolean(answerId),
        videoDisplay: ctqaId > 0,
        videoHighlight: isBought || audition,
        reportStatus: Number(reportStatus) || -1,
        answerId: Number(answerId) || -1,
        pid: 0,
        qid: id
      }))

      const data = {
        tagName,
        totalPage: isPractices ? practiceList.totalPage : questionList.totalPage,
        practiceList: isPractices ? practices : questions,
      }
      return data
    })
}

export function getRecommands (subject) {
  return fetch(`${config.api.zhikeApi.url}/products/recommend/${subject}`)
    .then(res => res.json())
    .then(json => {
      if (json.code === 0) {
        const data = json.data.map(item => ({
          id: item.id,
          name: item.name,
          orderCount: item.orderCount,
          link: `${config.site.zhike}/courses/${item.examinationName.toLowerCase()}/${item.id}.html`
        }))
        return data
      }
      throw new Error(json.msg)
    })
}

export function getReportStatus (answerId, token) {

  return new Promise((resolve, reject) => {
    const token = getUserInfo() ? getUserInfo().token : ''
    fetch(`${config.api.ti}/pigai/count?answerId=${answerId}&token=${token}`)
    .then(res => res.json())
    .then(({ code, data }) => {
      // 对话框类型 (0: 隐藏 1: 网络请求失败 2: 没有购买 3: 没有批改次数 4: 可提交批改 5:提交批改失败 6:提交批改成功)
      let type;
      let pigaiProductId;
      if (code === 'onlinep10612') {
        type = 7
      }
      if (data.permission && data.total > 0) {
        resolve({
          type:4,
          ...data,
        })
        // type = 4
      } else {
        type = data.permission ? 3 : 2;
        pigaiProductId = data.pigaiProductId;
      }
      resolve({type, pigaiProductId});
    }).catch(e => {
      resolve({type: 1, tip: e.message});
    })
  })
}

export function getReport (exerciseId) {
  return getReportBase(exerciseId)
    .then(json => {
      if (json.code !== 0) {
        throw new Error(json.msg)
      }

      const answers = json.data.reportList.map((
        { answerId, userAnswer, content, category }
      ) => {
        const isCorrect = userAnswer[0].isCorrect
        let answer = content.question_detail[0].answer
        userAnswer = userAnswer[0].answer

        if (!Array.isArray(userAnswer)) {
          if (typeof userAnswer === 'string') {
            userAnswer = userAnswer.split(',')
          } else if (typeof userAnswer === 'number') {
            userAnswer = [userAnswer]
          }
        }
        if (!Array.isArray(answer)) {
          answer = [answer]
        }
        return {
          answerId,
          category,
          answer,
          userAnswer,
          isCorrect,
          question: content.question_detail[0].question.text[0].raw,
        }
      })

      const time = json.data.timeCost
      return { answers, time }
    })
}

export function getUserRank () {
  return fetch(`${config.api.ti}/user/rank`)
    .then(res => res.json())
    .then(json => {
      if (json.code !== 0) { throw new Error(json.msg) }

      return json.data.list.map(item => {
        return {
          ...item,
          avatar: config.cdnCommon + item.avatar
        }
      })
    })
}

export function getUserStatistics (token) {
  return fetch(`${config.api.ti}/user/statistics?token=${token}`)
            .then(res => res.json())
}

export function getTextbook (params) {
  return fetch(`${config.api.ti}/textbook/exercises?${qs.stringify({ ...params, pageSize: 9 })}`)
    .then(res => res.json())
    .then(json => {
      if (json.code !== 0) { throw new Error(json.msg) }

      return {
        subjects: json.data.subjects.map(item => pick(item, ['id', 'name'])),
        categories: json.data.textbooks,
        cards: json.data.exercises.practiceList.map(item => ({ ...item, _tag_: false })),
        totalPage: json.data.exercises.totalPage
      }
    })
}

export function getTags (params) {
  return fetch(`${config.api.ti}/tags?${qs.stringify({ ...params, pageSize: 9 })}`)
    .then(res => res.json())
    .then(json => {
      if (json.code !== 0) { throw new Error(json.msg) }

      return {
        subjects: json.data.subjects,
        types: json.data.types,
        cards: json.data.tags.map(item => ({ ...item, _tag_: true })),
        totalPage: json.data.totalPage
      }
    })
}

const CATEGORY = {
  1: 'radio',     // 单选
  2: 'multi',     // 多选
  3: 'blank',     // 填空
  4: 'speaking',  // 口语
  5: 'writing'    // 写作
}
export function getQuestion (id) {
  return fetch(`${config.api.ti}/question/${id}`)
    .then(res => res.json())
    .then(json => {
      if (json.code !== 0) { throw new Error(json.msg) }

      return {
        id: json.data.id,
        name: json.data.name,
        category: CATEGORY[json.data.category],
        material: json.data.content.material,
        additionMaterial: json.data.content.addition_material,
        detail: json.data.content.question_detail,
        ctqa: json.data.sliceInfo,
        tipId: json.data.tipId,
        introduction: json.data.content.introduction,
        answerTime: json.data.answerTime,
        textLimit: json.data.textLimit
      }
    })
}

export function getPractice (id) {
  return fetch(`${config.api.ti}/practice/${id}`)
    .then(res => res.json())
    .then(json => {
      if (json.code !== 0) { throw new Error(json.msg) }

      return {
        name: json.data.name,
        questionIds: json.data.questionIds
      }
    })
}

export function getAnswerPageReports (exerciseId) {
  return getReportBase(exerciseId)
    .then(json => {
      if (json.code !== 0) { throw new Error(json.msg) }

      const answer = json.data.reportList.map(item => ({
        id: item.id,
        name: item.name,
        category: CATEGORY[item.category],
        material: item.content.material,
        detail: item.content.question_detail,
        userAnswer: item.userAnswer,
        additionMaterial: item.content.addition_material,
        isCorrect: item.isCorrect,
        sliceInfo: item.sliceInfo,
        tipId: item.tipId,
        reportStatus: item.reportStatus,
        answerId: item.answerId
      }))
      const time = json.data.timeCost
      const userGroup = json.data.userGroup || 1
      const userGroupName = json.data.userGroupName || null
      return { answer, time, userGroup, userGroupName}
    })
}

export function submitAnswer (payload) {
  return fetch(`${config.api.ti}/answer`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: qs.stringify(payload)
  }).then(res => res.json())
}

export function getAnswer (questionId, exerciseId, token, extra) {
  const query = {
    questionId,
    exerciseId,
    token,
    ...extra
  }

  return fetch(`${config.api.ti}/answer?${qs.stringify(query)}`)
    .then(res => res.json())
    .then(json => {
      if (json.code !== 0) { throw new Error(json.code === 'onlinep10' ? 'BAD_TOKEN' : json.msg) }

      return json.data
    })
}

export function getExerciseId (pid, qid, extra) {
  const payload = {
    id:   parseInt(pid, 10) === 0 ? parseInt(qid, 10) : parseInt(pid, 10),
    type: parseInt(pid, 10) === 0 ? 'question'        : 'practice',
    ...extra
  }

  return fetch(`${config.api.ti}/id/exercise`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: qs.stringify(payload)
  }).then(res => res.json())
    .then(json => {
      if (json.code !== 0) { throw new Error(json.msg) }

      return json.data.id
    })
}

export function uploadAudio (dataObj){
  let body = new window.FormData();
  body.append('file', dataObj.blobData);
  body.append('duration', dataObj.duration);
  return fetch(`${config.api.ti}/upload`, { method: "POST", body: body})
    .then(res => res.json())
    .then(json => {
      if(json.code !== 0) { throw new Error(json.msg)}
      return {
        path: json.data.path,
        duration: json.data.duration
      }
    })
}



/** WEBPACK FOOTER **
 ** ./src/common/api.js
 **/